<template>
  <div class="c_wrapper c_wrapper--950 c_cs_links">
    <div v-for="(link, index) in linksObj" :key="index">
      <CustomerStoryLink
        :custom-url="link.customUrl"
        :entry="link.entry"
        :asset="link.asset"
        :open-in-a-new-window="link.openInANewWindow"
        :link-label="link.linkLabel"
      />
    </div>
  </div>
</template>

<script>
import CustomerStoryLink from 'Components/2022_customer_story_links/CustomerStoryLink.vue';
export default {
  props: {
    linksObj: Array,
  },
  components: {
    CustomerStoryLink,
  },
};
</script>

<style lang="scss">
.c_cs_links {
  display: block;
  justify-content: space-between;
  padding-top: px_to_rem(10);
  padding-bottom: px_to_rem(20);
  @include mq($mq_sm_to_md) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: px_to_rem(30);
    padding-bottom: px_to_rem(40);
  }
  & > div {
    width: 100%;
    @include mq($mq_sm_to_md) {
      flex-basis: 50%;
      width: 50%;
    }
  }
}
</style>
